import { updateDiagramSelectAction, getDiagramSelectAction } from '@process-advisor/process-miner/processMiner/processMiner';

export type SelectActionProps = {
    isolate?: boolean;
    animate?: boolean;
    lifecycle?: boolean;
}

export const changeSelectAction = ({
    isolate,
    animate,
    lifecycle,
}: SelectActionProps) => {
    updateDiagramSelectAction({ isolate, animate, lifecycle });
};

export const getSelectAction = (): SelectActionProps => getDiagramSelectAction();
